// extracted by mini-css-extract-plugin
module.exports = {"ShareArticle":"ShareArticle_ShareArticle__3Owxg","copyMessage":"ShareArticle_copyMessage__x0OhM","icon":"ShareArticle_icon__e0_U_"};